export const from = ''; // some storyboards do not have a version
export const to = '1.0';

export function up(schema) {
  const newSchema = {
    image: [],
    logo: null,
    ...schema,
    version: to,
  };
  return newSchema;
}

export function down(schema) {
  return {
    ...schema,
    version: 0,
  };
}

export default {
  from,
  to,
  up,
  down,
};
